(function () {
  function getVariantSelects(dialog) {
    return dialog.querySelector('[data-style-with-variant-selects]');
  }

  function getVariants(dialog) {
    const variantsData = dialog.querySelector('[data-product-variants]');
    if (!variantsData) return [];

    try {
      return JSON.parse(variantsData.textContent);
    } catch (error) {
      return [];
    }
  }

  function getSelectedVariantScript(dialog) {
    return dialog.querySelector('[data-selected-variant]');
  }

  function getInitialVariant(dialog) {
    const selectedVariantScript = getSelectedVariantScript(dialog);
    if (!selectedVariantScript?.textContent?.trim()) return null;

    try {
      return JSON.parse(selectedVariantScript.textContent);
    } catch (error) {
      return null;
    }
  }

  function normalizeOptionValue(value) {
    return typeof value === 'string' ? value.trim() : value;
  }

  function getOptionGroups(variantSelects) {
    return Array.from(
      variantSelects.querySelectorAll('fieldset[data-option-position], .product-form__input--dropdown')
    ).sort((left, right) => {
      const leftPosition = Number(left.dataset.optionPosition || 0);
      const rightPosition = Number(right.dataset.optionPosition || 0);
      return leftPosition - rightPosition;
    });
  }

  function getSelectedValues(dialog) {
    const variantSelects = getVariantSelects(dialog);
    if (!variantSelects) return [];

    return getOptionGroups(variantSelects).map((group) => {
      const select = group.querySelector('select');
      if (select) return normalizeOptionValue(select.value);

      const checked = group.querySelector('input[type="radio"]:checked');
      return checked ? normalizeOptionValue(checked.value) : '';
    });
  }

  function findRadioByValue(group, optionValue) {
    const normalizedValue = normalizeOptionValue(optionValue);
    return Array.from(group.querySelectorAll('input[type="radio"]')).find(
      (radio) => normalizeOptionValue(radio.value) === normalizedValue
    );
  }

  function selectRadio(variantSelects, radio) {
    if (!radio || radio.disabled) return;

    variantSelects.querySelectorAll(`input[type="radio"][name="${CSS.escape(radio.name)}"]`).forEach((input) => {
      input.checked = input === radio;
    });
  }

  function applyVariantSelection(dialog, variant) {
    const variantSelects = getVariantSelects(dialog);
    if (!variantSelects || !variant?.options?.length) return false;

    const groups = getOptionGroups(variantSelects);
    let changed = false;

    groups.forEach((group, index) => {
      const optionValue = normalizeOptionValue(variant.options[index]);
      if (!optionValue) return;

      const select = group.querySelector('select');
      if (select) {
        if (normalizeOptionValue(select.value) !== optionValue) {
          select.value = optionValue;
          changed = true;
        }
        return;
      }

      const radio = findRadioByValue(group, optionValue);
      if (radio && !radio.checked) {
        selectRadio(variantSelects, radio);
        changed = true;
      }
    });

    return changed;
  }

  function findVariant(dialog, values) {
    const variants = getVariants(dialog);
    if (!variants.length) return null;

    const normalizedValues = values.map(normalizeOptionValue);

    if (normalizedValues.every(Boolean)) {
      const exact = variants.find(
        (variant) =>
          variant.options.length === normalizedValues.length &&
          variant.options.every(
            (option, index) => normalizeOptionValue(option) === normalizedValues[index]
          )
      );
      if (exact) return exact;
    }

    return (
      variants.find(
        (variant) =>
          variant.available &&
          normalizedValues.some(
            (value, index) => value && normalizeOptionValue(variant.options[index]) === value
          )
      ) ||
      variants.find((variant) =>
        normalizedValues.some(
          (value, index) => value && normalizeOptionValue(variant.options[index]) === value
        )
      ) ||
      null
    );
  }

  function resolveVariant(dialog, variant) {
    if (!variant?.id) return variant;

    const variants = getVariants(dialog);
    return variants.find((entry) => entry.id === variant.id) || variant;
  }

  function updateOptionLabels(dialog) {
    const variantSelects = getVariantSelects(dialog);
    if (!variantSelects) return;

    getOptionGroups(variantSelects).forEach((group) => {
      const selectedValue = group.querySelector('[data-selected-value]');
      if (!selectedValue) return;

      const select = group.querySelector('select');
      if (select?.value) {
        selectedValue.textContent = select.value;
        return;
      }

      const checked = group.querySelector('input[type="radio"]:checked');
      if (checked?.value) {
        selectedValue.textContent = checked.value;
      }
    });
  }

  function formatMoney(dialog, cents) {
    const priceEl = dialog.querySelector('[data-style-with-price]');
    const moneyFormat = priceEl?.dataset.moneyFormat;

    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function' && moneyFormat) {
      return Shopify.formatMoney(cents, moneyFormat);
    }

    return '$' + (cents / 100).toFixed(0);
  }

  function ensureDefaultSelection(dialog) {
    const variantSelects = getVariantSelects(dialog);
    if (!variantSelects) return;

    const values = getSelectedValues(dialog);
    if (values.every(Boolean) && findVariant(dialog, values)) return;

    const initialVariant = getInitialVariant(dialog);
    if (initialVariant) {
      applyVariantSelection(dialog, initialVariant);
    }
  }

  function syncVariant(dialog) {
    const variantSelects = getVariantSelects(dialog);
    const variantInput = dialog.querySelector('.product-variant-id');
    const priceEl = dialog.querySelector('[data-style-with-price]');
    const submitButton = dialog.querySelector('.style-with-quick-add__submit');
    const submitLabel = submitButton?.querySelector('.product-form__submit-label');
    const selectedVariantScript = getSelectedVariantScript(dialog);

    let variant = null;

    if (variantSelects) {
      variant = findVariant(dialog, getSelectedValues(dialog));
      updateOptionLabels(dialog);
    } else {
      variant = getInitialVariant(dialog);
      if (!variant?.id && variantInput?.value) {
        variant = resolveVariant(dialog, { id: Number(variantInput.value) });
      }
    }

    variant = resolveVariant(dialog, variant);

    if (selectedVariantScript && variant) {
      selectedVariantScript.textContent = JSON.stringify(variant);
    }

    if (variantInput) {
      variantInput.value = variant?.id || '';
      variantInput.disabled = !variant?.available;
    }

    if (priceEl && variant) {
      priceEl.textContent = formatMoney(dialog, variant.price);
    }

    if (submitButton && submitLabel) {
      if (!variant || !variant.available) {
        submitButton.setAttribute('disabled', 'disabled');
        submitLabel.textContent = window.variantStrings?.soldOut?.toUpperCase?.() || 'SOLD OUT';
      } else {
        submitButton.removeAttribute('disabled');
        submitLabel.textContent = window.variantStrings?.addToCart?.toUpperCase?.() || 'ADD TO CART';
      }
    }
  }

  function wireVariantInputs(dialog) {
    const variantSelects = getVariantSelects(dialog);
    if (!variantSelects || variantSelects.dataset.styleWithInputsWired === '1') return;
    variantSelects.dataset.styleWithInputsWired = '1';

    variantSelects.querySelectorAll('label[for]').forEach((label) => {
      const inputId = label.getAttribute('for');
      const input = inputId ? variantSelects.querySelector(`#${CSS.escape(inputId)}`) : null;
      label.removeAttribute('for');

      label.addEventListener('click', (event) => {
        event.preventDefault();

        if (input?.type === 'radio') {
          selectRadio(variantSelects, input);
          syncVariant(dialog);
        }
      });
    });

    variantSelects.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', () => syncVariant(dialog));
    });

    variantSelects.querySelectorAll('select').forEach((select) => {
      select.addEventListener('change', () => syncVariant(dialog));
    });
  }

  function initStyleWithQuickAddDialog(dialog) {
    if (dialog.dataset.styleWithQuickAddInit) return;
    dialog.dataset.styleWithQuickAddInit = '1';

    const panel = dialog.querySelector('.style-with-quick-add__panel');

    dialog.addEventListener('click', (event) => {
      if (panel && !panel.contains(event.target)) {
        dialog.close();
      }
    });

    dialog.querySelector('[data-style-with-quick-add-close]')?.addEventListener('click', (event) => {
      event.preventDefault();
      dialog.close();
    });

    dialog.addEventListener('close', () => {
      document.body.classList.remove('overflow-hidden');
      if (dialog._placeholder?.parentNode) {
        dialog._placeholder.parentNode.insertBefore(dialog, dialog._placeholder);
      }
    });

    wireVariantInputs(dialog);
    ensureDefaultSelection(dialog);
    syncVariant(dialog);
  }

  function openStyleWithQuickAdd(dialog) {
    if (!dialog) return;

    initStyleWithQuickAddDialog(dialog);
    wireVariantInputs(dialog);
    ensureDefaultSelection(dialog);
    syncVariant(dialog);

    if (!dialog._placeholder && dialog.parentNode) {
      dialog._placeholder = document.createComment('style-with-quick-add-anchor');
      dialog.parentNode.insertBefore(dialog._placeholder, dialog);
    }

    document.body.appendChild(dialog);

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    document.body.classList.add('overflow-hidden');
    dialog.querySelector('.style-with-quick-add__panel')?.focus();
  }

  function initStyleWithQuickAdd() {
    document.querySelectorAll('.style-with-quick-add').forEach(initStyleWithQuickAddDialog);

    document.querySelectorAll('[data-style-with-quick-add-open]').forEach((button) => {
      if (button.dataset.styleWithQuickAddBound) return;
      button.dataset.styleWithQuickAddBound = '1';

      button.addEventListener('click', () => {
        const dialogId = button.dataset.styleWithQuickAddOpen;
        const card = button.closest('.style-with-card');
        const dialog = card?.querySelector(`#${CSS.escape(dialogId)}`) || document.getElementById(dialogId);
        openStyleWithQuickAdd(dialog);
      });
    });
  }

  function initStyleWithDots() {
    document.querySelectorAll('.style-with-containers-wrapper').forEach((wrapper) => {
      const container = wrapper.querySelector('.style-with-container.is-active');
      const dotsWrap = wrapper.querySelector('.style-with__dots');
      if (!container || !dotsWrap || dotsWrap.dataset.styleWithDotsInit) return;
      dotsWrap.dataset.styleWithDotsInit = '1';

      const items = container.querySelectorAll('.style-with__item');
      if (items.length <= 1) {
        dotsWrap.hidden = true;
        return;
      }

      dotsWrap.innerHTML = '';
      items.forEach((item, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'style-with__dot' + (index === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Slide ' + (index + 1));
        dot.addEventListener('click', () => {
          item.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dotsWrap.appendChild(dot);
      });

      container.addEventListener(
        'scroll',
        () => {
          const scrollLeft = container.scrollLeft;
          const itemWidth = items[0]?.offsetWidth || 1;
          const activeIndex = Math.round(scrollLeft / (itemWidth + 12));
          dotsWrap.querySelectorAll('.style-with__dot').forEach((dot, index) => {
            dot.classList.toggle('is-active', index === activeIndex);
          });
        },
        { passive: true }
      );
    });
  }

  function init() {
    initStyleWithQuickAdd();
    initStyleWithDots();
  }

  window.initStyleWithQuickAdd = initStyleWithQuickAdd;
  window.initStyleWithDots = initStyleWithDots;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
